export default __webpack_public_path__ + "346298cbf85baeb49bd92fe26fa1095f.woff2";